//PreHarvest RadioButton Group options: 
const nameOptionMap=[
    {name: 'Pruning', options: getPruningOptions},
    {name: 'Fertility', options: getFertilityOptions},
    {name: 'ColorUniformity', options: getColorUniformityOptions},
    {name: 'ShotBerries', options: getShotBerryOptions},
    {name: 'WaterBerries', options: getWaterBerryOptions},   
    {name: 'BunchDensity', options: getBunchDensityOptions},
    {name: 'Rudiment', options: getRudimentOptions},
    {name: 'OverallAppeal', options: getOverallAppealOptions},
    {name: 'BerryTexture', options: getBerryTextureOptions},
    {name: 'Skin', options: getSkinOptions},
    {name: 'Stem', options: getStemOptions},
    {name: 'BerrySize', options: getSizeUniformityOptions},
    {name: 'AcidAtEval', options: getAcidAtEvalOptions},
    {name: 'Attachment', options: getAttachmentOptions},
    {name: 'Astringency', options: getAstringencyOptions},
    {name: 'Flavor', options: getFlavorOptions},
    {name: 'EatingQuality', options: getEatingQualityOptions},
    {name: 'SkinStructure', options: getSkinStructureOptions},
    {name: 'CapStem', options: getCapStemOptions},
    {name: 'Brush', options: getBrushOptions},
    {name: 'TreatmentPlan', options: getTreatmentPlanOptions},
    {name: 'Type', options: getTypeOptions},
    {name: 'Harvest', options: getHarvestOptions},
    {name: 'BudBreak', options: getBudBreakOptions},
    {name: 'RainResistance', options: getRainResistanceOptions},
    {name: 'BerryAttachment', options: getBerryAttachmentOptions},
    {name: 'SkinTexture', options: getSkinTextureOptions},
    //{name: 'BerryTexture', options: getBerryTextureOptions2},
    //{name: 'EatingQuality', options: getEatingQualityOptions2},
    {name: 'BerryColorW', options: getBerryColorWhiteOptions},
    {name: 'BerryColorR', options: getBerryColorRedOptions},
    {name: 'FirmBerries', options: getFirmBerriesOptions},
    {name: 'RachisDehydration', options: getRachisDehydrationOptions},
    {name: 'BerryWrinkle', options: getBerryWrinkleOptions},
    {name: 'BerrySplit', options: getBerrySplitOptions},
    {name: 'NeckCrack', options: getNeckCrackOptions},
    {name: 'Decay', options: getDecayOptions},
    {name: 'PackingMethod', options: getPackingMethodOptions},
    {name: 'Harvest', options: getHarvestOptions},
    {name: 'RainResistance', options: getRainResistanceOptions},
    {name: 'Chilling', options: getChillingOptions},
    {name: 'Girdling', options: getGirdlingOptions},
    {name: 'PhenologicalStage', options: getPhenologicalStageOptions},
    {name: 'PhenologicalPhase', options: getPhenologicalPhaseOptions},
    {name: 'FruitColor', options: getFruitColorOptions},
    {name: 'Pathology', options: getPathologyOptions}  
]
//Page 1:
const pruningOptions = [
    {
        label: "Long/Cane",
        value: "Long/Cane",
        index: 1,
        grade: 0
    },
    {
        label: "Half long",
        value: "Half long",
        index: 2,
        grade: 0
    },
    {
        label: "Rich Spur",
        value: "Rich Spur",
        index: 3,
        grade: 0
    },
    {
        label: "Spur",
        value: "Spur",
        index: 4,
        grade: 0
    }
];

export function getPruningOptions(){
    return pruningOptions;
};

export function getOptionsByName(name){
    let optionFunc = null;
    nameOptionMap.map((value) => {
        if(value.name === name){
        optionFunc=value.options;
        }
    });
    return optionFunc;
};

export function getLabelByIndex(name, ind){
    // console.log('name: '+name+', ind: '+ind);
    let label = null;
    const getOptions=getOptionsByName(name);
    if(getOptions!==null){
        getOptions().map((option)=>{
            if(option.index === ind)
                label = option.label;
            return option.label;
        });
    }
    // console.log('label: '+label);
    return label;
};

export function getFertilityOptions(){
    const FertilityOptions = [
        {
            label: "Very Fertile 5",
            value: "Very Fertile",
            index: 1,
            grade: 5
        },
        {
            label: "Fertile 3",
            value: "Fertile",
            index: 2,
            grade: 3
        },
        {
            label: "Not Fertile 1",
            value: "Not Fertile",
            index: 3,
            grade: 1
        }
    ];
    return FertilityOptions;
};

export function getColorUniformityOptions(){
    const ColorUniformityOptions = [
        {
            label: "Uniform 5",
            value: "Uniform",
            index: 1,
            grade: 5
        },
        {
            label: "Mainly Uniform 3",
            value: "Mainly Uniform",
            index: 2,
            grade: 3
        },
        {
            label: "Not Uniform 1",
            value: "Not Uniform",
            index: 3,
            grade: 1
        }
    ];
    return ColorUniformityOptions;
};

export function getShotBerryOptions(){
    const ShotBerryOptions = [
        {
            label: "None 5",
            value: "None",
            index: 1,
            grade: 5
        },
        {
            label: "Up to 10 - 3",
            value: "Up to 10",
            index: 2,
            grade: 3
        },
        {
            label: "Over 10 - 1",
            value: "Over 10",
            index: 3,
            grade: 1
        }
    ];
    return ShotBerryOptions;
};

export function getWaterBerryOptions(){
    const WaterBerryOptions = [
        {
            label: "None-Few (up to 5 per bunch) 5",
            value: "None-Few (up to 5 per bunch)",
            index: 1,
            grade: 5
        },
        {
            label: "More than 5 per bunch 1",
            value: "More than 5 per bunch",
            index: 2,
            grade: 1
        }
    ];
    return WaterBerryOptions;
};

export function getBunchDensityOptions(){
    const BunchDensityOptions = [
        {
            label: "Loose 5",
            value: "Loose",
            index: 1,
            grade: 5
        },
        {
            label: "Dense 3",
            value: "Dense",
            index: 2,
            grade: 3
        },
        {
            label: "Very Dense 1",
            value: "Very Dense",
            index: 3,
            grade: 1
        }
    ];
    return BunchDensityOptions;
};

//Page 2:
export function getRudimentOptions(){
    const RudimentOptions = [
        {
            label: "Sterile 5",
            value: "Sterile",
            index: 1,
            grade: 5
        },
        {
            label: "Soft & Small 3",
            value: "SoftSmall",
            index: 2,
            grade: 3
        },
        {
            label: "Soft & Large 1",
            value: "SoftLarge",
            index: 3,
            grade: 1
        }
    ];
    return RudimentOptions;
};

export function getOverallAppealOptions(){
    const OverallAppealOptions = [
        {
            label: "Excellent 5",
            value: "Excellent",
            index: 1,
            grade: 5
        },
        {
            label: "Good 3",
            value: "Good",
            index: 2,
            grade: 3
        },
        {
            label: "Average 2",
            value: "Average",
            index: 3,
            grade: 2
        },
        {
            label: "Poor 1",
            value: "Poor",
            index: 4,
            grade: 1
        }
    ];
    return OverallAppealOptions;
};

export function getSkinOptions(){
    const SkinOptions = [
        {
            label: "Thin 5",
            value: "Thin",
            index: 1,
            grade: 5
        },
        {
            label: "Med - Thin 3",
            value: "Med - Thin",
            index: 2,
            grade: 3
        },
        {
            label: "Med - Thick 1",
            value: "Med - Thick",
            index: 3,
            grade: 1
        },
        {
            label: "Thick 1",
            value: "Thick",
            index: 4,
            grade: 1
        }
    ];
    return SkinOptions;
};

export function getBerryTextureOptions(){
    const BerryTextureOptions = [
        {
            label: "Crispy 5" ,
            value: "Crispy",
            index: 1,
            grade: 5
        },
        {
            label: "Meaty 3",
            value: "Meaty",
            index: 2,
            grade: 3
        },
        {
            label: "Juicy 1",
            value: "Juicy",
            index: 3,
            grade: 1
        }
    ];
    return BerryTextureOptions;
};

export function getStemOptions(){
    const StemOptions = [
        {
            label: "Green 5",
            value: "Green",
            index: 1,
            grade: 5
        },
        {
            label: "Dark Green 4",
            value: "Dark Green",
            index: 2,
            grade: 4
        },
        {
            label: "Creamy 4",
            value: "Creamy",
            index: 3,
            grade: 4
        }
    ];
    return StemOptions;
};

export function getSizeUniformityOptions(){
    const SizeUniformityOptions = [
        {
            label: "Uniform 5",
            value: "Uniform",
            index: 1,
            grade: 5
        },
        {
            label: "Mainly Uniform 3",
            value: "Mainly Uniform",
            index: 2,
            grade: 3
        },        
        {
            label: "Not Uniform 1",
            value: "Not Uniform",
            index: 3,
            grade: 1
        }
    ];
    return SizeUniformityOptions;
};

//Page 3:
export function getAcidAtEvalOptions(){
    const AcidAtEvalOptions = [
        {
            label: "Low 5",
            value: "Low",
            index: 1,
            grade: 5
        },
        {
            label: "Med 3",
            value: "Med",
            index: 2,
            grade: 3
        },
        {
            label: "High 1",
            value: "High",
            index: 3,
            grade: 1
        }
    ];
    return AcidAtEvalOptions;
};

export function getAttachmentOptions(){
    const AttachmentOptions = [
        {
            label: "Very Good 5",
            value: "Very Good",
            index: 1,
            grade: 5
        },
        {
            label: "Good 4",
            value: "Good",
            index: 2,
            grade: 4
        },
        {
            label: "Fair 3",
            value: "Fair",
            index: 3,
            grade: 3
        },
        {
            label: "Bad 1",
            value: "Bad",
            index: 4,
            grade: 1
        }
    ];
    return AttachmentOptions;
};

export function getAstringencyOptions(){
    const AstringencyOptions = [
        {
            label: "None 5",
            value: "None",
            index: 1,
            grade: 5
        },
        {
            label: "Light 3",
            value: "Light",
            index: 2,
            grade: 3
        },
        {
            label: "High 1",
            value: "High",
            index: 3,
            grade: 1
        }
    ];
    return AstringencyOptions;
};

export function getFlavorOptions(){
    const FlavorOptions = [
        {
            label: "Caramel 5",
            value: "Caramel",
            index: 1,
            grade: 5
        },
        {
          label: "Muscat 5",
          value: "Muscat",
          index: 2,
          grade: 5
        },
        {
          label: "None 4",
          value: "None",
          index: 3,
          grade: 4
        },
        {
          label: "Exotic 4",
          value: "Light Labruska (Aromatic)",
          index: 4,
          grade: 4
        },
        {
          label: "Foxy 2",
          value: "Heavy Labruska",
          index: 5,
          grade: 2
        }
    ];
    return FlavorOptions;
};

export function getEatingQualityOptions(){
    const EatingQualityOptions = [
        {
            label: "Excellent 5",
            value: "Excellent",
            index: 1,
            grade: 5
        },
        {
            label: "Good 3",
            value: "Good",
            index: 2,
            grade: 3
        },
        {
            label: "Not Good 1",
            value: "Not Good",
            index: 3,
            grade: 1
        }
    ];
    return EatingQualityOptions;
};

export function getSkinStructureOptions(){
    const SkinStructureOptions = [
        {
            label: "Wax 5",
            value: "Wax",
            index: 1,
            grade: 5
        },
        {
            label: "Smooth 4",
            value: "Smooth",
            index: 2,
            grade: 4
        },
        {
            label: "Rough 2",
            value: "Rough",
            index: 3,
            grade: 2
        },
        {
            label: "Bloom 1",
            value: "Bloom",
            index: 4,
            grade: 1
        }
    ];
    return SkinStructureOptions;
};

export function getCapStemOptions(){
    const CapStemOptions = [
        {
            label: "Normal 5",
            value: "Normal",
            index: 1,
            grade: 5
        },
        {
            label: "Large 3",
            value: "Large",
            index: 2,
            grade: 3
        },
        {
            label: "Small 1",
            value: "Small",
            index: 3,
            grade: 1
        }
    ];
    return CapStemOptions;
};

export function getBrushOptions(){
    const BrushOptions = [
        // {
        //     label: "Long Thin 5",
        //     value: "Long Thin",
        //     index: 1,
        //     grade: 5
        // },
        // {
        //     label: "Long Thick 4",
        //     value: "Long Thick",
        //     index: 2,
        //     grade: 4
        // },
        // {
        //     label: "Medium Thin 3",
        //     value: "Medium Thin",
        //     index: 3,
        //     grade: 3
        // },
        // {
        //     label: "Medium Thick 2",
        //     value: "Medium Thick",
        //     index: 4,
        //     grade: 2
        // },
        // {
        //     label: "Short Thin 2",
        //     value: "Short Thin",
        //     index: 5,
        //     grade: 2
        // },
        // {
        //     label: "Short Thick 1",
        //     value: "Short Thick",
        //     index: 6,
        //     grade: 1
        // }

        {
            label: "Large 5",
            value: "Large",
            index: 1,
            grade: 5
        },
        {
            label: "Medium 3",
            value: "Medium",
            index: 2,
            grade: 3
        },
        {
            label: "Small 1",
            value: "Small",
            index: 3,
            grade: 1
        },
    ];
    return BrushOptions;
};

export function getTreatmentPlanOptions(){
    const TreatmentPlanOptions = [
        {
          label: "Excellent",
          value: "Excellent",
          index: 1
        },
        {
          label: "Reevaluate",
          value: "Reevaluate",
          index: 2
        },
        {
          label: "Disqualified",
          value: "Disqualified",
          index: 3
        }
    ];
    return TreatmentPlanOptions;
};

  //PostHarvest RadioButton Group options:
  //Page 1:
export function getBerryAttachmentOptions(){
    const BerryAttachmentOptions = [
        {
            label: "Excellent 5",
            value: "Excellent",
            index: 1,
            grade: 5
        },
        {
            label: "Good 4",
            value: "Good",
            index: 2,
            grade: 4
        },
        {
            label: "Medium 3",
            value: "Medium",
            index: 3,
            grade: 3
        },
        {
            label: "Bad 1",
            value: "Bad",
            index: 4,
            grade: 1
        }
    ];
    return BerryAttachmentOptions;
};

export function getSkinTextureOptions(){
    const SkinTextureOptions = [
        {
            label: "Thin 5",
            value: "Thin",
            index: 1,
            grade: 5
        },
        {
            label: "Med - Thin 4",
            value: "Med - Thin",
            index: 2,
            grade: 4
        },
        {
            label: "Med - Thick 2",
            value: "Med - Thick",
            index: 3,
            grade: 2
        },
        {
            label: "Thick 1",
            value: "Thick",
            index: 4,
            grade: 1
        }
    ];
    return SkinTextureOptions;
};

export function getBerryTextureOptions2(){
    const BerryTextureOptions = [
        {
            label: "Crispy 5" ,
            value: "Crispy",
            index: 1,
            grade: 5
        },
        {
            label: "Meaty 5",
            value: "Meaty",
            index: 2,
            grade: 5
        },
        {
            label: "Juicy 3",
            value: "Juicy",
            index: 3,
            grade: 3
        },
        {
            label: "Soft 1",
            value: "Soft",
            index: 3,
            grade: 1
        }
    ];
    return BerryTextureOptions;
};

export function getEatingQualityOptions2(){
    const EatingQualityOptions = [
        {
            label: "Excellent 5",
            value: "Excellent",
            index: 1,
            grade: 5
        },
        {
            label: "Good 4",
            value: "Good",
            index: 2,
            grade: 4
        },
        {
            label: "Medium 3",
            value: "Medium",
            index: 3,
            grade: 3
        },
        {
            label: "Bad 1",
            value: "Bad",
            index: 4,
            grade: 1
        }
    ];
    return EatingQualityOptions;
};

export function getBerryColorWhiteOptions(){
    const BerryColorWhiteOptions = [
        {
            label: "Good 5",
            value: "Good",
            index: 1,
            grade: 5
        },
        {
            label: "Glassy 3",
            value: "Glassy",
            index: 2,
            grade: 3
        },
        {
            label: "Browning 2",
            value: "Browning",
            index: 3,
            grade: 2
        },
        {
            label: "Marks 2",
            value: "Marks",
            index: 4,
            grade: 2
        }
    ];
    return BerryColorWhiteOptions;
};

export function getBerryColorRedOptions(){
    const BerryColorRedOptions = [
        {
            label: "Good 5",
            value: "Good",
            index: 1,
            grade: 5
        },
        {
            label: "Dulling 3",
            value: "Dulling",
            index: 2,
            grade: 3
        },
        {
            label: "Loss of Shine 2",
            value: "Loss of Shine",
            index: 3,
            grade: 2
        },
        {
            label: "Sulfur Bleaching 1",
            value: "Sulfur Bleaching",
            index: 4,
            grade: 1
        }
    ];
    return BerryColorRedOptions;
};

export function getFirmBerriesOptions(){
    const FirmBerriesOptions = [
        {
            label: "Over 90% 5",
            value: "Over 90%",
            index: 1,
            grade: 5
        },
        {
            label: "70% - 90% 3",
            value: "70% - 90%",
            index: 2,
            grade: 3
        },
        {
            label: "Under 70% 1",
            value: "Under 70%",
            index: 3,
            grade: 1
        }
    ];
    return FirmBerriesOptions;
};

  //page 2:
export function getRachisDehydrationOptions(){
    const RachisDehydrationOptions = [
        {
            label: "Green 5",
            value: "Green",
            index: 1,
            grade: 5
        },
        {
            label: "Green & Brown 3",
            value: "Green & Brown",
            index: 2,
            grade: 3
        },
        {
            label: "Dry & Brown 1",
            value: "Dry & Brown",
            index: 3,
            grade: 1
        }
    ];
    return RachisDehydrationOptions;
};

export function getBerryWrinkleOptions(){
    const BerryWrinkleOptions = [
        {
            label: "Under 10% about 10 berries 5",
            value: "Under 10% about 10 berries",
            index: 1,
            grade: 5
        },
        {
            label: "Over 10% 11 berries or more 1",
            value: "Over 10% 11 berries or more",
            index: 2,
            grade: 1
        }
    ];
    return BerryWrinkleOptions;
};

export function getBerrySplitOptions(){
    const BerrySplitOptions = [
        {
            label: "Under 5% about 5 berries 5",
            value: "Under 5% about 5 berries",
            index: 1,
            grade: 5
        },
        {
            label: "Over 10% 10 berries or more 1",
            value: "Over 10% 10 berries or more",
            index: 2,
            grade: 1
        }
    ];
    return BerrySplitOptions;
};

export function getNeckCrackOptions(){
    const NeckCrackOptions = [
        {
            label: "Under 5% 5",
            value: "Under 5%",
            index: 1,
            grade: 5
        },
        {
            label: "5% - 30% 3",
            value: "5% - 30%",
            index: 2,
            grade: 3
        },
        {
            label: "Over 30% 1",
            value: "Over 30%",
            index: 3,
            grade: 1
        }
    ];
    return NeckCrackOptions;
};

export function getDecayOptions(){
    const DecayOptions = [
        {
            label: "Under 10% 5",
            value: "Under 10%",
            index: 1,
            grade: 5
        },
        {
            label: "Over 10% 1",
            value: "Over 10%",
            index: 2,
            grade: 1
        }
    ];
   return DecayOptions;
};

export function getPackingMethodOptions(){
    const PackingMethodOptions = [
        {
            label: "Sulfur pad",
            value: "Sulfur pad",
            index: 1,
            grade: 0 // 5
        },
        {
            label: "Smart pack",
            value: "Smart pack",
            index: 2,
            grade: 0 // 3
        },
        {
            label: "No Sulfur",
            value: "No Sulfur",
            index: 3,
            grade: 0 //1
        }
    ];
    return PackingMethodOptions;
};

//Treatment RadioButton Group options:

//Page 1:
export function getTypeOptions(){
    const TypeOptions = [
        {
            label: "Black",
            value: "Black",
            index: 1
        },
        {
            label: "Red",
            value: "Red",
            index: 2
        },
        {
            label: "White",
            value: "White",
            index: 3
        }
    ];
    return TypeOptions;
};

export function getHarvestOptions(){
    const HarvestOptions = [
        {
            label: "Early",
            value: "Early",
            index: 1
        },
        {
            label: "Mid",
            value: "Mid",
            index: 2
        },
        {
            label: "Late",
            value: "Late",
            index: 3
        }
      ];
    return HarvestOptions;
};

export function getBudBreakOptions(){
    const BudBreakOptions = [
        {
            label: "Non-Uniform",
            value: "Non-Uniform",
            index: 1
        },
        {
            label: "Uniform",
            value: "Uniform",
            index: 2
        }
      ];
    return BudBreakOptions;
};

export function getRainResistanceOptions(){
    const RainResistanceOptions = [
        {
            label: "Unknown",
            value: "Unknown",
            index: 1
        },
        {
            label: "Yes",
            value: "Yes",
            index: 2
        },
        {
            label: "No",
            value: "No",
            index: 3
        }
    ];
    return RainResistanceOptions;
};

export function getChillingOptions(){
    const ChillingOptions = [
        {
            label: "Low",
            value: "Low",
            index: 1
        },
        {
            label: "Medium",
            value: "Medium",
            index: 2
        },
        {
            label: "High",
            value: "High",
            index: 3
        }
    ];
    return ChillingOptions;
};

export function getGirdlingOptions(){
    const GirdlingOptions = [
        {
            label: "At Sizing",
            value: "At Sizing",
            index: 1
        },
        {
            label: "At Veraison",
            value: "At Veraison",
            index: 2
        },
        {
            label: "No",
            value: "No",
            index: 3
        }
      ];
      return GirdlingOptions;
};

export function getPhenologicalStageOptions() {
    const PhenologicalStageOptions = [
        {
            label: "Pre-flowering",
            value: "Pre-flowering",
            index: 1
        },
        { 
            label: "50% Flowering",
            value: "50% Flowering",
            index: 2
        },
        { 
            label: "110% Flowering / Fruit set",
            value: "110% Flowering / Fruit set",
            index: 3            
        },
        {
            label: "5-8 mm fruit",
            value: "5-8 mm fruit",
            index: 4                   
        },
        { 
            label: "Pea size fruit",
            value: "Pea size fruit",
            index: 5 
        },
        { 
            label: "Cluster closure",
            value: "Cluster closure",
            index: 6 
        } ,           
        { 
            label: "Veraison",
            value: "Veraison",
            index: 7 
        } , 
    ]; 
    return PhenologicalStageOptions;
};

export function getPhenologicalPhaseOptions() {
    const PhenologicalPhaseOptions = [
        {
            label: "Bud break",
            fieldId: "BudBreakId",
            fieldName: "BudBreakDate",
            index: 1
        },
        { 
            label: "Flowering",
            fieldId: "FloweringId",
            fieldName: "FloweringDate",
            index: 2
        },
        { 
            label: "Veraison",
            fieldId: "VeraisonId",
            fieldName: "VeraisonDate",
            index: 3            
        },
        {
            label: "Ripeness",
            fieldId: "RipenessId",
            fieldName: "RipenessDate",
            index: 4                   
        },
    ]; 
    return PhenologicalPhaseOptions;
};

export function getFruitColorOptions(){
    const FruitColorOptions = [
        {
            label: "Black",
            value: "Black",
            index: 1
        },
        {
            label: "Red",
            value: "Red",
            index: 2
        },
        {
            label: "White",
            value: "White",
            index: 3
        }
    ];
    return FruitColorOptions;
};

export function getPathologyOptions(){
    const PathologyOptions = [
        {
            label: "Non 5",
            value: "Non",
            index: 1,
            grade: 5
        },
        {
            label: "Moderate 3",
            value: "Moderate",
            index: 2,
            grade: 3
        },
        {
            label: "Severe 1",
            value: "Severe",
            index: 3,
            grade: 1
        }
    ];
    return PathologyOptions;
};

export function getValueByIndex(RGBName,index){
  
};